import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const DueTodayRow = styled(Flex)<{ isOneClickSmallTest?: boolean }>`
    margin-bottom: ${({ isOneClickSmallTest }) => (isOneClickSmallTest ? "-8px" : "0")};
`;
